import React, {useRef, useState} from "react";
import {Form, Button, Input} from "antd";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import SmsService from "../../service/noAuth/nursecare/SmsService";
import MainActions from "../../action/main/MainActions";
import SwjwLoginActions from "../../action/swjwlogin/SwjwLoginActions";
import AccountBindModal from "./AccountBindModal";

export const CustomInput = ({value, onChange, suffix, style, inputProps}) => {
    return (
        <div
            style={{
                height: 42,
                borderRadius: 4,
                border: "1px solid #dfe3e7",
                display: "flex",
                alignItems: "center",
                ...style,
            }}
        >
            <Input
                value={value}
                onChange={onChange}
                style={{
                    border: "none",
                    boxShadow: "none",
                    flex: 1,
                }}
                {...inputProps}
            />
            {suffix}
        </div>
    );
};

const SmsCodeInput = ({value, onChange, number}) => {
    const [countDown, setCountDown] = useState(0);
    const intervalRef = useRef();
    const disabled = _.isEmpty(number) || countDown > 0;
    const senSms = async () => {
        setCountDown(60);
        intervalRef.current = setInterval(() => {
            setCountDown((prev) => {
                if (prev === 1) {
                    clearInterval(intervalRef.current);
                }
                return prev - 1;
            });
        }, 1000);
        
        await SmsService.sendAsync({
            mobile: number,
            biz: "SMS-LOGIN",
        });
    };

    return (
        <CustomInput
            style={{width: 240}}
            inputProps={{placeholder: "验证码"}}
            onChange={onChange}
            value={value}
            suffix={(
                <Button
                    onClick={() => senSms()}
                    disabled={disabled}
                    type="link"
                    style={{
                        padding: 0,
                        color: disabled ? "#b3daff" : "#0084ff",
                        marginRight: 11,
                    }}
                >
                    {countDown > 0 ? `已发送(${countDown}s)` : "发送验证码"}
                </Button>
        )}
        
        />
    );
};


function SwjwLoginView({
    dataContext,
    actions,
}) {
    const formRef = useRef();
    const handleLogin = async () => {
        const values = await formRef.current.validateFields();
        actions.smsLogin(values);
    };
    const handleBindAccount = async (values) => {
        const phoneInfo = await formRef.current.validateFields();
        actions.bindAccount({...phoneInfo, ...values});
    };
    return (
        <div
            style={{
                position: "absolute",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                display: "flex",
                height: "100%",
                flex: 1,
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                background: "#0084ff",
            }}
        >
            <div
                style={{
                    height: 400,
                    width: 480,
                    borderRadius: 12,
                    background: "#FFF",
                    padding: "64px 0 24px 0",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <div
                    style={{
                        fontSize: 24,
                        fontWeight: 500,
                        color: "#111f2c",
                        marginBottom: 32,
                    }}
                >
                    手机验证码登录
                </div>
                <Form
                    ref={formRef}
                    requiredMark="none"
                >
                    <Form.Item
                        label=""
                        name="mobile"
                        rules={[{required: true, message: "请输入手机号"}]}
                        style={{
                            marginBottom: 16,
                        }}
                    >
                        <CustomInput style={{width: 240}} inputProps={{placeholder: "手机号"}} />
                    </Form.Item>
                    <Form.Item
                        noStyle
                        dependencies={["mobile"]}
                    >
                        {
                            ({getFieldValue}) => {
                                const mobile = getFieldValue("mobile");
                                return (
                                    <Form.Item
                                        label=""
                                        name="smsCode"
                                        rules={[{required: true, message: "请输入验证码"}]}
                                        style={{marginBottom: 0}}
                                    >
                                        <SmsCodeInput number={mobile} />
                                    </Form.Item>
                                );
                            }
                        }
                    </Form.Item>
                </Form>
                <Button
                    onClick={handleLogin}
                    style={{
                        background: "#0084ff",
                        color: "#FFF",
                        height: 42,
                        width: 240,
                        marginTop: 44,
                        borderRadius: 4,
                    }}
                >
                    登录
                </Button>
                {/*  <div style={{flex: 1}} />
                <div>
                    <Button
                        type="link"
                        onClick={() => {
                            const newPathName = `${_.chain(location.pathname)
                                .split("/")
                                .slice(1)
                                .dropRight(1)
                                .join("/")
                                .value()}/accountlogin.html`;
                            const url = new URL(newPathName, location.origin);
                            const hospitalId = localStorage.getItem("RENYUAN_HOSPITAL_ID");
                            if (hospitalId) {
                                url.searchParams.set("hospitalId", hospitalId);
                            }
                            location.replace(url.toString());
                        }}
                    >
                        切换到账号登入
                    </Button>
                </div> */}
            </div>
            {
                dataContext.accountBindModalVisible && (
                    <AccountBindModal
                        onOk={handleBindAccount}
                        onClose={() => {
                            actions.update({
                                accountBindModalVisible: false,
                            });
                        }}
                    />
                )
            }
        </div>
    );
}


export default connect(
    state => ({
        dataContext: state.swjwLoginViewModel,
    }),
    dispatch => ({
        actions: bindActionCreators(SwjwLoginActions, dispatch),
    })
)(SwjwLoginView);
